/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  PriceChart constants index
 */

// fetching
export const DONE_FETCHING_CITY_PRICE_CHART_DATA =
  '@@nzr/priceChart/detail/DONE_FETCHING_CITY_PRICE_CHART_DATA'
export const DONE_FETCHING_HOOD_PRICE_CHART_DATA =
  '@@nzr/priceChart/detail/DONE_FETCHING_HOOD_PRICE_CHART_DATA'
export const ERROR_FETCHING_CITY_PRICE_CHART_DATA =
  '@@nzr/priceChart/detail/ERROR_FETCHING_CITY_PRICE_CHART_DATA'

export const ERROR_FETCHING_HOOD_PRICE_CHART_DATA =
  '@@nzr/priceChart/detail/ERROR_FETCHING_HOOD_PRICE_CHART_DATA'
export const START_FETCHING_CITY_PRICE_CHART_DATA =
  '@@nzr/priceChart/detail/START_FETCHING_CITY_PRICE_CHART_DATA'
export const START_FETCHING_HOOD_PRICE_CHART_DATA =
  '@@nzr/priceChart/detail/START_FETCHING_HOOD_PRICE_CHART_DATA'

// storing
export const CLEAR_PRICE_CHART_DATA = '@@nzr/priceChart/detail/CLEAR_PRICE_CHART_DATA'
export const CLEAR_HOOD_PRICE_CHART_DATA = '@@nzr/priceChart/detail/CLEAR_HOOD_PRICE_CHART_DATA'
export const SET_CITY_PRICE_CHART_DATA = '@@nzr/priceChart/detail/SET_CITY_PRICE_CHART_DATA'
export const SET_HOOD_PRICE_CHART_DATA = '@@nzr/priceChart/detail/SET_HOOD_PRICE_CHART_DATA'
